import { forwardRef } from "react";
import { Dialog, DialogContent, Slide } from "@mui/material";
import { CrossIcon } from "../../assets";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const InfoDialog = ({
  open,
  setOpen,
  handleSubmit,
  infoDetail,
  icon,
  buttonText = "Okay",
  buttonClass,
  buttonWidth = "120px",
}) => {
  const handleClose = (e) => {
    if (e) {
      e.stopPropagation();
      e.preventDefault();
    }
    setOpen(false);
  };

  const handleOkayClick = () => {
    setOpen(false);
    handleSubmit();
  };
  return (
    <>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
        fullWidth
        PaperProps={{
          style: {
            maxWidth: "700px",
            width:"100%",
            height:"500px",
            minHeight:"500px",
            maxHeight:"500px",
            borderRadius: "24px",
            backgroundColor: "#262626",
            border: "1px solid rgba(255, 255, 255, 0.16)"
          },
        }}
      >
        <DialogContent className="!p-5 relative font-satoshi">
            <img
              src={CrossIcon}
              alt="crossIcon"
              className="ml-auto cursor-pointer absolute top-5 right-5"
              onClick={handleClose}
            />
          <div id="alert-dialog-slide-description" className="flex items-center h-full">
            <div className="max-w-[508px] mx-auto flex flex-col gap-11 items-center">
              {icon && (
                <div className="w-[100px] h-[100px] flex justify-center items-center rounded-full">
                  <img src={icon} alt="icon" className="w-full h-full" />
                </div>
              )}
              <div className="w-full flex flex-col gap-3 mt-4">
                <div className="font-medium text-[32px] leading-10 text-center text-white">
                  {infoDetail.heading}
                </div>
                {infoDetail?.innerContent && (
                  <div
                    className={`text-center ${
                      infoDetail?.innerContentClass
                        ? infoDetail?.innerContentClass
                        : ""
                    }`}
                  >
                    {infoDetail?.innerContent}
                  </div>
                )}
              </div>

              {/* <button
                className={`btn h-12 flex justify-center items-center bg-custom-primary text-white font-medium py-[14px] text-center mt-8 rounded-lg w-full max-w-[${buttonWidth}] disabled:opacity-75 flex-1 px-[32px] font-hankengrotesk ${buttonClass}`}
                onClick={handleOkayClick}
              >
                {buttonText}
              </button> */}
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default InfoDialog;
